import { IonContent, IonPage } from '@ionic/react';
import React from 'react';
import styled from 'styled-components';

import { PaywallSectionPaymentOnPage } from '@/pages/Paywall/sections/PaymentOnPage';

import { OnboardingPaywallSectionAccessList } from '../V1/sections/AccessList';
import { OnboardingPaywallSectionGoPremium } from '../V1/sections/GoPremium';
import { OnboardingPaywallImagination } from '../V1/sections/Imagination';

import { SectionImages } from './sections/Images';
import { SectionTimer } from './sections/Timer';

const PaywallDefaultShortStyles = styled(IonPage)`
  body.dark & {
    ion-content {
      --background: linear-gradient(
        360deg,
        #2b0e21 0%,
        #14111e 49.18%,
        #1e0f34 100%
      );
      background: linear-gradient(
        360deg,
        #2b0e21 0%,
        #14111e 49.18%,
        #1e0f34 100%
      );
    }
  }

  padding-top: 0;

  ion-content {
    --background: #fff;
    background: #fff;
  }
`;

const PaywallDefaultShort: React.FC = () => {
  return (
    <PaywallDefaultShortStyles>
      <IonContent>
        <SectionImages />

        <OnboardingPaywallSectionGoPremium />

        <OnboardingPaywallSectionAccessList />

        <OnboardingPaywallImagination />

        <SectionTimer />

        <PaywallSectionPaymentOnPage withSafeness />
      </IonContent>
    </PaywallDefaultShortStyles>
  );
};

export default PaywallDefaultShort;
